import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./csscomponents/CarInfoCards.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";

export default function CarInfoCards(props) {
    const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [brand, setBrand] = useState("");
  const [carName, setCarName] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [carType, setCarType] = useState("");
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [kilometer, setKilometer] = useState("");

  const navigate = useNavigate();

  const carBrands = [
    "Aston Martin", "Audi", "Bentley", "BMW", "BYD", "Chevrolet", "Datsun", "Ferrari", "Fiat", "Fisker", "Ford", "Great Wall Motors",
    "Honda", "Hyundai", "Isuzu", "Jaguar", "Jeep", "Kia", "Koenigsegg", "Lamborghini", "Land Rover", "Lexus", "Lotus", "Mahindra",
    "Maruti Suzuki", "Maserati", "McLaren", "Mercedes-Benz", "MG Motor", "Nissan", "Ora", "Pagani", "Polestar", "Porsche", "Renault",
    "Rolls-Royce", "Skoda", "Tata Motors", "Tesla", "Toyota", "Volkswagen", "Volvo"
  ];

  const handleImageChange = (e) => setImage(Array.from(e.target.files));

  const handleSubmit = (e) => {
    e.preventDefault();
    const imagesData = image.map((img, index) => ({ [`image${index + 1}`]: img }));
    props.addOldCar(
      props.login.token,
      props.login.user_id,
      brand,
      carName,
      fuelType,
      carType,
      price,
      discountedPrice,
      kilometer,
      imagesData
    );
    navigate("/overview");
  };

  return (
    <div className="car-form-container">
      <div className="car-form-card">
        <h2 className="form-title">Car Information</h2>

        <form onSubmit={handleSubmit} className="car-form">
          {/* Image Upload */}
          <div className="form-group full-width">
            <label className="custom-file-upload">
              Upload Car Images
              <input type="file" multiple onChange={handleImageChange} required />
            </label>
            <div className="image-preview">
              {image.map((img, idx) => (
                <img key={idx} src={URL.createObjectURL(img)} alt={`Selected ${idx + 1}`} />
              ))}
            </div>
          </div>

          {/* Form Fields */}
          <div className="form-fields">
            <div className="form-group">
              <label>Brand</label>
              <select value={brand} onChange={(e) => setBrand(e.target.value)} required>
                <option value="">Select Brand</option>
                {carBrands.map((b) => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label>Car Name</label>
              <input type="text" value={carName} onChange={(e) => setCarName(e.target.value)} required />
            </div>

            <div className="form-group">
              <label>Fuel Type</label>
              <select value={fuelType} onChange={(e) => setFuelType(e.target.value)} required>
                <option value="">Select Fuel</option>
                <option value="Petrol">Petrol</option>
                <option value="Diesel">Diesel</option>
                <option value="CNG">CNG</option>
                <option value="LPG">LPG</option>
                <option value="Electric">Electric</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>

            <div className="form-group">
              <label>Car Type</label>
              <select value={carType} onChange={(e) => setCarType(e.target.value)} required>
                <option value="">Select Type</option>
                <option value="SUV">SUV</option>
                <option value="Sedan">Sedan</option>
                <option value="Hatchback">Hatchback</option>
              </select>
            </div>

            <div className="form-group">
              <label>Price</label>
              <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} required />
            </div>

            <div className="form-group">
              <label>Discounted Price</label>
              <input type="number" value={discountedPrice} onChange={(e) => setDiscountedPrice(e.target.value)} required />
            </div>

            <div className="form-group full-width">
              <label>Kilometer</label>
              <input type="number" value={kilometer} onChange={(e) => setKilometer(e.target.value)} required />
            </div>
          </div>

          <div className="form-submit">
            <button type="submit">Next</button>
          </div>
        </form>

      </div >
      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={props.snackbar.message}
      />

    </div >
  );
}
